import React, {Component} from 'react';
import PropTypes from 'prop-types';
import Drawer from 'react-motion-drawer';
import {popoverContainerHOC} from 'BZPopover';

class Preview extends Component {
    render() {
        const { show, content, closeWindow, expand, expandButtonText = 'expand', color='#000', customClass = '', previewContainerTop } = this.props;
        return <Drawer
            handleWidth={show ? 200 : 0}
            open={show}
            right
            noTouchOpen
            noTouchClose
            width={500}
            height="calc(100vh - 65px)"
            overlayClassName={'hide'}
            drawerStyle={drawerStyle(previewContainerTop)}
            className={`preview-window-container ${customClass}`}>
            <div>
                <div style={headerStyle(customClass)}>
                    <div style={innerShadowBoxStyle} />
                    <div style={innerHeaderStyle}>
                        <span style={closeIconContainerStyle(color)}>
                            <i className="icon-close" onClick={closeWindow} style={closeIconStyle} />
                        </span>
                        <span onClick={expand} style={textButtonStyle(color)}>{expandButtonText}</span>
                    </div>
                </div>
                <div style={contentStyle}>
                    {content}
                </div>
                <div style={blurBackGroundStyle} />
            </div>
        </Drawer>;
    }
}

Preview.propTypes = {
    show: PropTypes.bool.isRequired,
    content: PropTypes.any,
    closeWindow: PropTypes.func,
    expand: PropTypes.func,
    color: PropTypes.string,
    expandButtonText: PropTypes.string
};

export const PreviewWindow = popoverContainerHOC(Preview);

const innerShadowBoxStyle = {
    height: '60px',
    width: '100%',
    position: 'absolute',
    top: '-60px',
    boxShadow: '12px 0 20px 0 rgba(50,51,60,0.2)'
};
const drawerStyle = previewContainerTop => ({
    boxShadow: '0 10px 20px 0 rgba(50,51,60,0.2)'
});
const blurBackGroundStyle = {
    backgroundImage: 'conic-gradient(var(--cards-fill-color, rgba(255, 255, 255, 0.9))), conic-gradient(var(--page-background-color, rgba(255, 255, 255, 0.9)))',
    position: 'absolute',
    width: '100%',
    height: '100%'
};
const headerStyle = customClass => ({
    backgroundColor: customClass ? 'rgba(0, 0, 0, 0.2)' : 'var(--cards-fill-color, #F5F5F7)',
    position: 'fixed',
    width: '100%',
    zIndex: '1'
});
const innerHeaderStyle = {
    backgroundColor: 'transparent',
    width: '100%',
    padding: '0'
};
const closeIconContainerStyle = color => ({
    backgroundColor: `var(--page-main-color, ${color})`,
    height: '35px',
    width: '35px',
    display: 'inline-block',
    padding: '5px 0 0 5px'
});
const closeIconStyle = {
    color: 'var(--page-contrast-to-main-color, #FFF)',
    cursor: 'pointer',
    fontSize: '25px'
};
const textButtonStyle = color => ({
    display: 'inline-block',
    cursor: 'pointer',
    textTransform: 'uppercase',
    color: 'var(--page-contrast-to-main-color, #FFF)',
    backgroundColor: `var(--page-main-color, ${color})`,
    fontWeight: '300',
    fontSize: '11px',
    height: '35px',
    width: '112px',
    verticalAlign: 'top',
    padding: '10px 0 0 21px',
    position: 'relative',
    left: '354px'
});
const contentStyle = {
    backgroundImage: 'conic-gradient(var(--cards-fill-color, #FFF)), conic-gradient(var(--page-background-color, #FFF))',
    padding: '34px 0 60px',
    overflow: 'auto'

};
